import styled from "styled-components";
import { useStore } from "@/lib/storeData/StoreContext";
import { MobileLanguage } from "@/assets/Icons/MobileLanguage";
import { LanguageSwitcher } from "../NavBar/LanguageSwitcher/LanguageSwitcher";
import type { ValueContainerProps, StylesConfig } from "react-select";
import { ZIndex } from "@/shared/globals/types";
import { themeColor } from "@/shared/styles-utils";
import { LazySelectValueContainer } from "@/shared/globals/LazyElements/react-select";

export const MobileLanguageSwitcher = () => {
  const { locales } = useStore();
  if (locales.length === 1) return null;
  return (
    <LanguageSwitcher
      instanceId="mobile-language-switcher"
      menuPlacement="top"
      styles={selectStyles}
      components={{ ValueContainer }}
    />
  );
};

/**
 * Components
 */

const ValueContainer = ({ children, ...props }: ValueContainerProps) => {
  return (
    <LazySelectValueContainer {...props}>
      <FlexRow>
        <MobileLanguage />
        {children}
      </FlexRow>
    </LazySelectValueContainer>
  );
};

/**
 * Styles
 */

const selectStyles: StylesConfig = {
  container: (provided) => ({
    ...provided,
    width: "100%",
    display: "block",
    position: "sticky",
    bottom: 0,
    zIndex: ZIndex["DEFAULT"],
  }),
  control: (provided) => ({
    ...provided,
    backgroundColor: "white",
    border: "solid 1px #dfe3e8",
    fontWeight: "500",
    cursor: "pointer",
    width: "100%",
    padding: 5,
    boxShadow: "none",
    ":hover": {
      borderColor: "unset",
    },
  }),
  option: (provided) => ({
    ...provided,
    backgroundColor: "white",
  }),
};

const FlexRow = styled.div`
  background-color: ${themeColor("white")};
  display: flex;
  align-items: center;
  svg {
    margin: 0 8px;
    color: ${({ theme }) => theme.bg.wash};
  }
`;
